import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[paceCoreNumberOnly]',
})
export class NumberOnlyDirective {
    @Input() public maxLength: number;
    @Input() public maxValue: number;

    // eslint-disable-next-line
    @HostListener('paste', ['$event']) public blockPaste(e: KeyboardEvent) {
        e.preventDefault();
    }

    // eslint-disable-next-line
    @HostListener('copy', ['$event']) public blockCopy(e: KeyboardEvent) {
        e.preventDefault();
    }

    // eslint-disable-next-line
    @HostListener('cut', ['$event']) public blockCut(e: KeyboardEvent) {
        e.preventDefault();
    }
    public constructor(private el: ElementRef) {}

    @HostListener('keydown', ['$event'])
    public onKeyDownEvent(event: KeyboardEvent): boolean | undefined {
        if (
            event.key === 'Backspace' ||
            event.key === 'Delete' ||
            event.key === 'ArrowLeft' ||
            event.key === 'ArrowRight' ||
            event.key === 'Tab'
        ) {
            return;
        }
        // additional check, since html5 input number allow dashes
        if (event.key === '-') {
            return false;
        }
        const nativeEl = <HTMLInputElement>this.el.nativeElement;
        const numberOnlyPattern = this.maxLength ? '^[0-9]{0,' + this.maxLength.toString() + '}$' : '^[0-9]$';
        const toMatchValue = nativeEl.value + event.key;
        const keyValue = +event.key;
        const newValue =
            nativeEl.selectionStart === 0
                ? (isNaN(keyValue) ? '' : keyValue.toString()) + nativeEl.value
                : nativeEl.value + (isNaN(keyValue) ? '' : keyValue.toString());
        const regexTest = new RegExp(numberOnlyPattern).test(toMatchValue);
        if (this.maxValue) {
            return regexTest && +newValue <= this.maxValue;
        }
        return regexTest;
    }
}
